<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت  سوالات متداول</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;پاسخ جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingCats" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.fA_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.fA_Id)" dark v-if="!item.fA_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.fA_Id)" dark v-else> فعال</v-btn>
                            </template>
                            <template v-slot:[`item.fA_Logo`]="{ item }">
                                <v-btn target="_blank" :href="LogoUrl+`${item.fA_Logo}`" icon small><v-icon small>fas fa-eye</v-icon></v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.fA_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New Cat From Dialog-->
            <v-dialog max-width="600" persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت پاسخ جدید</span>
                              <span v-else>ویرایش پاسخ  &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="cancelEditItem" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px !important;border-left:1px solid rgb(200,200,200)"><!--Register New Cat From-->
                                    <div style="padding-top:23px;padding-bottom:5px;font-weight:bolder;font-size:17px">تنظیمات اصلی</div>
                                   
                                    <v-autocomplete :items="FaqCategories" item-text="f_Title" item-value="f_Id" color="#2a2d45" outlined dense v-model="FaqCat" label="دسته بندی "></v-autocomplete>

                                    <v-text-field color="#2a2d45" outlined dense v-model="CatTitle" label="عنوان " ></v-text-field>
                                    
                                    <v-text-field color="#2a2d45" outlined dense v-model="SortField" label="ترتیب نمایش" ></v-text-field>
                                    
                                    <v-textarea color="#2a2d45" outlined dense v-model="QuestionBody" label="پاسخ"></v-textarea>

                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="CatStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>

                                  
                                    <v-btn @click="registerCategory" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<style>
.v-color-picker__canvas canvas
{
    display: block !important;
    min-width: 100% !important;
    height: 100% !important;
}
</style>
<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
.operationBoxDesign
{
    display: flex;
    align-items: center;
    border-radius: 0px;
    justify-content: space-evenly;
    min-height: 50px;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    padding-left: 10px;
    /* border: 1px solid rgb(207, 207, 207); */
    background-color: #fff;
    margin-bottom: 4px;
    box-shadow: 0px 0px 4px rgba(207, 207, 207,0.5);
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
const FTYPES = require('../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../constant/setting/Default/AllowedFileSize');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
export default {
    name:"faq",
   components: {
            Loading,
            JsonExcel
        },
    data:()=> ({
        ShowOnProduct:false,
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        selectedLogoSource: '',
        catLogoSelectionDialog:false,
        CatCreationDialog:false,
        CatImageName:"",
        searchcategory:"",
        isLoadingCats:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"دسته بندی ",value:"fA_CatTitle",sortable:true,align:"right"},
            {text:"عنوان",value:"fA_Title",sortable:true,align:"right"},
            {text:"وضعیت",value:"fA_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        ParentCat:"",
        CatTitle:"",
        CatSortField:"",
        CatStatus:"",
        seo:{},
        originalItems:[],
        catLogoData:require('../../assets/logo.png'),
        ALLOEWDIMGSIZE:{},
        LogoUrl:"",
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "پاسخ اصلی":"fA_ParentTitle",
            "عنوان":"fA_Title",
            "سطح":"fA_Level",
            "ترتیب نمایش":"fA_OrderField",
            "وضعیت":"fA_Status",
            "فایل لوگو":"fA_Logo",
            "تنظیمات سئو":"fA_Seo",
        },
        MaxUsedLevelCount:0,
        ColorHexCode:"",
        SortField:1,
        FaqCat:0,
        QuestionBody:"",
        FaqCategories:[]
    }),
    async created()
    {
        let vm = this;
        vm.LogoUrl = ApiUrl.PLabelLogo;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadCategories();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadCategories();
        }
    },
    methods:{
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.FA_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteFaq,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadCategories();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.FA_Id = id;
            await axios.post(ApiUrl.ActiveFaq,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadCategories();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.FA_Id = id;
            await axios.post(ApiUrl.DisableFaq,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadCategories();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.FaqCat = 0;
            vm.CatTitle = null;
            vm.SortField = 1;
            vm.CatStatus = true;
            vm.QuestionBody = null;
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(item)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.CatTitle = item.fA_Title;
            vm.CatStatus = item.fA_Status;
            vm.SortField = item.fA_SortField;
            vm.QuestionBody = item.fA_Answer;
            vm.FaqCat = item.fA_CatId;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async loadCategories()
        {
            let vm = this;
            vm.isLoadingCats = true;

            await axios.post(ApiUrl.LoadFaq,{withCredentials: true}).then(async (res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                }
                await vm.loadFaqCategoriesCombo();
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async loadFaqCategoriesCombo()
        {
            let vm = this;
            await axios.post(ApiUrl.LoadFaqCategoryCombo,{withCredentials: true}).then(async (res)=>{
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.FaqCategories = data.data;
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },

        async registerCategory()
        {
            let vm = this;
            let Model = {};
            Model.FA_CatId = vm.FaqCat;
            Model.FA_Title = vm.CatTitle;
            Model.FA_SortField = vm.SortField;
            Model.FA_Status = vm.CatStatus;
            Model.FA_Answer = vm.QuestionBody;
            let url = ApiUrl.AddFaq;
            if(vm.inEditingItem)
            {
                Model.FA_Id = vm.EditSelectedItem.fA_Id;
                url = ApiUrl.UpdateFaq;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadCategories();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        },
        SeoChanged(data)
        {
            this.seo = data;
        }
    }
}
</script>